
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'


export default {
components: {
XHeader,
XInput,
XButton,
Group,
Cell,
Checker,
CheckerItem,
Checklist,
Flexbox,
FlexboxItem
},
data() {
return {
isShowChapterList: false,
chapterList: [],
chapterAll: [],
chapters: [],
chapterNames: [],
subjectTypeList: [],
paperName: "",
paperScore: "100",
showPaperScore: "100",
paperTime: "120",
showPaperTime: "120",
subjectType: [],
chapterType: "0"
};
},
created() {
this.paperName =
this.$store.getters.getClassInfo.CourseName +
(this.$route.query.paperCount + 1);

this.$http({
method: "post",
url: "wxexam.ashx?op=LoadParaForNewPaper",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId
}
})
.then(response => {

if (response.status == 200 && response.data.errcode == 0) {
if (response.data.data != undefined &&response.data.data.length > 0 ) {







response.data.data.forEach(item => {
if(item.citem=="papername")
this.paperName = item.cvalue;
else if(item.citem == "paperscore"){
this.paperScore = item.cvalue;
this.showPaperScore = item.cvalue;
}
else if(item.citem == "papertime"){
this.paperTime = item.cvalue;
this.showPaperTime = item.cvalue;
}
});
}
}
})
.catch(function(error) {
console.log("error:" + error);
});

this.$http({
method: "post",
url: "wxexam.ashx?op=LoadTypesForNewPaper",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
this.subjectTypeList = response.data.data;
this.subjectType = [];
response.data.data.forEach(item => {
this.subjectType.push(item.isubjecttype);
});
}
})
.catch(function(error) {
console.log("error:" + error);
});

this.$http({
method: "post",
url: "wxexam.ashx?op=LoadChapterForNewPaper",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
this.chapterList = [];
response.data.data.forEach(chapter => {
this.chapterList.push({
key: chapter.ichapterid,
value: chapter.cchaptername,
inlineDesc: "共" + chapter.icount + "题"
});
this.chapterAll.push(chapter.ichapterid);
});
}
})
.catch(function(error) {
console.log("error:" + error);
});
},
methods: {
clearChapterNames() {
this.chapters = [];
this.chapterNames = [];
},
showChapterList() {
this.chapterType = "1";
this.isShowChapterList = true;
},
checkAll() {
this.chapters = this.chapterAll;
},
checkNone() {
this.chapters = [];
},
enterChapter() {
this.chapterNames = [];
this.chapterList.forEach(chapter => {
this.chapters.forEach(item => {
if (chapter.key == item) {
this.chapterNames.push(
chapter.value + "（" + chapter.inlineDesc + "）"
);
}
return;
});
});

this.isShowChapterList = false;
},
submitPaper() {
this.$http({
method: "post",
url: "wxexam.ashx?op=BuildNewPaper",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId,
totalScore: this.paperScore,
totalTime: this.paperTime,
paperName: this.paperName,
typelist: this.typeList,
chapterIdList: this.chapterIdList
}
})
.then(response => {
if (response.data.errcode == 0) {
this.$vux.toast.text("创建试卷成功成功", "bottom");
this.$router.go(-1);
}
else{
this.$vux.toast.text(response.data.errmsg, "bottom");
}
})
.catch(function(error) {
console.log("error:" + error);
});
}
},
computed: {
typeList: function() {
if (this.subjectType != "") {
return JSON.stringify(this.subjectType)
.replace("[", "")
.replace("]", "");
} else {
return undefined;
}
},
chapterIdList: function() {
if (this.chapters != undefined && this.chapters.length > 0) {
return JSON.stringify(this.chapters)
.replace("[", "")
.replace("]", "");
} else {
return undefined;
}
}
}
};



// WEBPACK FOOTER //
// ./src/components/BuildPaper.vue